module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DialogBox', {
    attrs: {
      "title": "Task Details",
      "settings": _vm.settings,
      "save-on-enter": ""
    },
    on: {
      "save": _vm.saveTask
    }
  }, [_c('div', {
    staticClass: "pa-3"
  }, [_c('v-text-field', {
    ref: "focus",
    attrs: {
      "label": "Task Description"
    },
    model: {
      value: (_vm.task.title),
      callback: function($$v) {
        _vm.$set(_vm.task, "title", $$v)
      },
      expression: "task.title"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex-large"
  }, [_c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-bottom": "15px",
      "flex-grow": "1"
    }
  }, [_c('UserChooser', {
    staticStyle: {
      "margin": "auto"
    },
    attrs: {
      "contact": _vm.user,
      "contacts": _vm.users,
      "label": "Assigned To"
    },
    on: {
      "select": _vm.userSelected
    },
    model: {
      value: (_vm.task.assigned),
      callback: function($$v) {
        _vm.$set(_vm.task, "assigned", $$v)
      },
      expression: "task.assigned"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v(_vm._s(_vm._f("dueString")(_vm.task.due)) + "\n                    "), _c('span', {
    staticClass: "grey--text"
  }, [_vm._v(_vm._s(_vm._f("stamp")(_vm.task.stamp)))])]), _vm._v(" "), _c('div', {
    staticClass: "small-text light-text"
  }, [_vm._v(_vm._s(_vm.task.hint))])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "25px"
    }
  }, [_c('v-date-picker', {
    attrs: {
      "no-title": ""
    },
    on: {
      "input": _vm.pickerClicked
    },
    model: {
      value: (_vm.task.due),
      callback: function($$v) {
        _vm.$set(_vm.task, "due", $$v)
      },
      expression: "task.due"
    }
  })], 1)])], 1), _vm._v(" "), _c('template', {
    slot: "footer"
  }, [_c('DeleteButton', {
    attrs: {
      "disabled": _vm.isDisabled
    },
    on: {
      "delete": function($event) {
        return _vm.deleteTask(_vm.task)
      },
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
      }
    }
  }), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "right": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "text": "",
            "color": (_vm.task.important ? 'primary' : 'grey lighten-1'),
            "icon": ""
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              $event.preventDefault();
              return _vm.$set(_vm.task, 'important', !_vm.task.important)
            }
          }
        }, on), [_c('v-icon', [_vm._v("mdi-alert-circle")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Important")])]), _vm._v(" "), (_vm.showEmailNotification) ? _c('v-tooltip', {
    attrs: {
      "right": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "text": "",
            "color": (_vm.sendEmailNotification ? 'primary' : 'grey lighten-1'),
            "icon": ""
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              $event.preventDefault();
              _vm.sendEmailNotification = !_vm.sendEmailNotification
            }
          }
        }, on), [_c('v-icon', [_vm._v("email")])], 1)]
      }
    }], null, false, 540679804)
  }, [_vm._v(" "), _c('span', [_vm._v("Send notification to " + _vm._s(_vm.notificationRecipient))])]) : _vm._e()], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-402879e8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/TaskDialog.vue
// module id = 2522
// module chunks = 1